module.exports = __webpack_public_path__ + "img/dingding.ad9fd1c9.png";